import { inject, computed } from 'vue';

export default function useLocate() {
  const { locale } = useI18n()
  const getConfigJson = inject('getConfigJson', () => ({}));
  const getCommonConfigJson = inject('getCommonConfigJson', () => ({}));
  const setLangJsonConfigMap = inject('setLangJsonConfigMap');

  const langJson = computed(() => {
    let res={};
    if(getCommonConfigJson && typeof getCommonConfigJson === 'function' ){
      Object.assign(
        res,
        getCommonConfigJson().langJson
      )
    }
    if(getConfigJson && typeof getConfigJson === 'function' ){
      Object.assign(
        res,
        getConfigJson().langJson
      )
    }
    
    return res;
  });
 
  const langCodeProxyMap = {
    "zh-CN":"hans",
    "zh-TW":"hant",
    "vi_VN":"vi",
    "ja_JP":"ja",
    "en":"en",
  }
  const nowLocale = computed(() => {
    let res='hans';
    
    if(locale.value&&langCodeProxyMap[locale.value]){
      res=langCodeProxyMap[locale.value];
    }
    return res;
  });

  const getLocaleText = (text) => {
    
    if (process.client&&typeof setLangJsonConfigMap === 'function' && text) {
       
      setLangJsonConfigMap(text);
    }
    return langJson.value[text] && langJson.value[text][nowLocale.value] ? langJson.value[text][nowLocale.value] : text;
  };

  return {
    langJson,
    nowLocale,
    getLocaleText,
  };
}
